import { ThemeProvider } from "@emotion/react";
import { Box, BoxProps, createTheme, FormLabel } from "@mui/material";
import { STheme } from "components/styles";
import { atom, useRecoilValue } from "recoil";

type SMsgProps = Pick<BoxProps, "gridColumn" | "gridRow">;

export const msgState = atom<string>({
  key: "msgState",
  default: "",
});

export const SMsg = ({ gridColumn, gridRow, ...props }: SMsgProps) => {
  const msg = useRecoilValue(msgState);
  return (
    <ThemeProvider theme={theme}>
      <Box display="grid" gridColumn={gridColumn} gridRow={gridRow}>
        <FormLabel {...props}>{msg}</FormLabel>
      </Box>
    </ThemeProvider>
  );
};

const theme = createTheme(
  {
    components: {
      MuiFormLabel: {
        styleOverrides: {
          root: {
            paddingLeft: "4px",
            paddingTop: "5px",
            paddingBottom: "0px",
            fontSize: "0.85rem",
            color: STheme.labels.required,
          },
        },
      },
    },
  },
  { ...STheme }
);
